import { createAction, props } from '@ngrx/store';

export enum UserConfigActionType {
  UserSetInitalValuesByMarket = '[User Config] Set inital stage values by market',
  ToggleSpecialEquipmentAccordion = '[User Config] TOGGLE a special equipment accordion',
  ToggleLights = '[User Config] TOGGLE lights',
  ToggleThreeSixtySlider = '[User Config] TOGGLE threeSixty slider',
  ToggleConvertible = '[User Config] TOGGLE convertible',
  UpdateSelectedPerspective = '[User Config] UPDATE selected perspective',
  DeleteSelectedPerspective = '[User Config] DELETE selected perspective',
  UpdatePostalCode = '[User Config] Update postal code',
  RemovePostalCode = '[User Config] Remove postal code'
}

export const userConfigAccordionToggle = createAction(
  UserConfigActionType.ToggleSpecialEquipmentAccordion,
  props<{
    payload: {
      accordion: string;
    };
  }>()
);

export const userConfigUpdateSelectedPerspective = createAction(
  UserConfigActionType.UpdateSelectedPerspective,
  props<{
    payload: {
      selectedPerspective: string;
    };
  }>()
);

export const userConfigDeleteSelectedPerspective = createAction(UserConfigActionType.DeleteSelectedPerspective);

export const userConfigUpdatePostalCode = createAction(
  UserConfigActionType.UpdatePostalCode,
  props<{ postalCode?: string }>()
);

export const userConfigRemovePostalCode = createAction(UserConfigActionType.RemovePostalCode);
